import base from './base'
import axios from './request'

export const loginTech = (params)=>{
    return axios.post(`${base}/api/v3/pub/login/tech`, params)
}

export const getKxResource = (params)=>{
    return axios.post(`${base}/api/v3/onlineBook/resources`, params)
}

